import { modalAnatomy as parts } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';
const {
  definePartsStyle,
  defineMultiStyleConfig
} = createMultiStyleConfigHelpers(parts.keys);
const baseStyle = props => definePartsStyle(Object.assign({}, props.theme.components.Modal.baseStyle, {
  header: Object.assign({}, props.theme.components.Modal.baseStyle.header, {
    paddingX: 8,
    borderBottom: '1px solid',
    borderBottomColor: 'GREYSCALE.SATELLITE',
    paddingBottom: 3
  }),
  body: Object.assign({}, props.theme.components.Modal.baseStyle.body, {
    py: 3,
    px: 8
  }),
  footer: Object.assign({}, props.theme.components.Modal.baseStyle.footer, {
    paddingTop: 3,
    px: 8,
    paddingBottom: 8,
    justifyContent: 'initial'
  })
}));
export const modalTheme = defineMultiStyleConfig({
  baseStyle
});